// @ts-ignore
import { NotificationManager } from 'react-notifications';

function generateNotification(
  type: 'info' | 'success' | 'warning' | 'error',
  message: string
) {
  switch (type) {
    case 'info':
      NotificationManager.info(message, '', 5000);
      break;
    case 'success':
      NotificationManager.success(message, '', 5000);
      break;
    case 'warning':
      NotificationManager.warning(message, '', 5000);
      break;
    case 'error':
      NotificationManager.error(message, '', 5000);
      break;
  }
}

const withAlert = async (
  func: () => Promise<{ error: string }>,
  successMessage: string = 'Успешно',
  errorMessage: string = 'Не удалось выполнить операцию',
  onSuccess?: () => any
): Promise<void> => {
  const { error } = await func();

  if (error === '' || !error) {
    generateNotification('success', successMessage);
    onSuccess && onSuccess();
  } else {
    generateNotification('error', errorMessage);
  }
};

export { generateNotification, withAlert };
